import React from 'react';
import { withContent } from '../../../hoc/withContext';
import './HeroSaleBlock.scss';
import { IContent } from '../../../types';
import { HeroSaleContent } from '../../../types/content';
import Image from "../../UI/Image/Image";
import BackgroundImage from "../../UI/Image/BackgroundImageElement";

// @ts-ignore
import Fade from "react-reveal/Fade";

import { getShopURL, sendEvent } from '../../../utils';

interface IHeroSaleProps {
  context?: IContent;
  initialized?: any;
}

const heroContent = (info: HeroSaleContent, delayMultiplier: number) => (
  <React.Fragment>
    {info.image && (
      <div className="image">
        <Fade delay={delayMultiplier * 100} left duration={600} distance="50px">
          <Image
            imageName={info.image}
            altText={""}
          />
        </Fade>
      </div>
    )}
    <div className="hero-content">
      {delayMultiplier === 1 && (
        <div className="logo">
          <Image
            imageName={"ubisoft-forward-logo.svg"}
            altText={""}
          />
        </div>
      )}
      {info.title && (<div className="hero-title">{info.title}</div>)}
      <div className="hero-description" dangerouslySetInnerHTML={{ __html: info.description }} />
      <div className="hero-action">
        {info.cta && info.cta.link && info.cta.type && info.cta.title && process.env.REACT_APP_PAGE_TYPE !== 'category' && (
          <div className="action">
            <a
              className={info.cta.type}
              href={getShopURL() + info.cta.link}
              onClick={() => sendEvent(info.cta.tracking)}
              data-alt-text={info.cta.title}
            >
              <span>{info.cta.title}</span>
            </a>
          </div>
        )}
      </div>
    </div>
  </React.Fragment>
);

const HeroSaleBlock = ({ context }: IHeroSaleProps) => {
  const { hero_sale } = context;
  const { is_active, left, right, bg_mobile, legal } = hero_sale;

  return is_active && (
    <div className="block-container-hero_sale">
      <BackgroundImage
        classNames={["block-hero_sale"]}
        imageName="bg-hero_sale.jpg"
      >
        <BackgroundImage
          classNames={["content-left"]}
          imageName={bg_mobile.top}
        >
          {heroContent(left, 1)}
        </BackgroundImage>
        <BackgroundImage
          classNames={["content-right"]}
          imageName={bg_mobile.bottom}
        >
          {heroContent(right, 3)}
        </BackgroundImage>
        {legal && legal.title && legal.link && (
          <div className="hero-legal">
            <a
              href={legal.link}
              onClick={() => sendEvent(legal.tracking)}
            >
              {legal.title}
            </a>
          </div>
        )}
      </BackgroundImage>
    </div>
  );
};

export default withContent(HeroSaleBlock);
